import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from './layout.component';
import {HomeComponent} from './home/home.component';
import {LayoutRoutingModule} from './layout-routing.module';
import {MatToolbarModule} from '@angular/material/toolbar';
import {WaitingComponent} from './waiting/waiting.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {WaitingService} from './waiting/waiting.service';
import {MatListModule} from '@angular/material/list';
import {MatExpansionModule} from '@angular/material/expansion';
import { ParkComponent } from '../park/park/park.component';
import { MenuContextService } from './services/menu-context.service';
import { MenuExpandContextService } from './services/menu-expand-context.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
	declarations: [LayoutComponent, HomeComponent, WaitingComponent],
	imports: [
		CommonModule,
		LayoutRoutingModule,
		MatToolbarModule,
		MatIconModule,
		MatListModule,
		MatSidenavModule,
		MatExpansionModule,
        MatMenuModule,
        MatProgressBarModule,
        MatButtonModule,
	], providers: [
		WaitingService,
		MenuContextService,
		MenuExpandContextService
	]
})
export class LayoutModule {
}
